import React from "react";
import { useHistory, useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import { Formik } from "formik";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import { useEffect, useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function EditCountry() {
  const classes = useStyles();

  const history = useHistory();
  const EmpId = localStorage.getItem("EmpId");
  const [Tug_data, setTug_data] = useState([]);
  const [Commodilist, setCommodilist] = useState([]);
  let { id } = useParams();

  // const getlistcom = async() =>{
  //   try{
  //     const d = await api
  //     .get("api/commodity/list")
  //      .then((response) =>{
  //       setCommodilist(response.data)

  //       console.log(response);
  //      })
  //   }
  //   catch (e){

  //   }
  // }

  const data_params = { id: id };
  const getData = async () => {
    try {
      const data = await api
        .post("api/country/detail", data_params)
        .then((response) => {
          if (response.data.length !== 0) {
            [].concat(response.data).map((res) => {
              // console.log(res);
              setTug_data(res);
              // console.log(Tug_data);
            });
            // response.data.map
          } else {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ผิดพลาด!",
                "ไม่พบรหัสอ้างอิงดังกล่าว !",
                "error"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/Setting/EditCountry");
                }
              });
            });
            // console.log("Nodata" + response);
          }
          //   console.log(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };
  //api call
  useEffect(() => {
    if (id) {
      getData();
    }
    // getlistcom()
    // console.log(id);
    // GET request using axios inside useEffect React hook

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, []);
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          ประเทศ
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Country
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / {!id ? "Create Country" : "Edit Country"}
            </Typography>
          </Grid>
        </Grid>

        <Formik
          enableReinitialize
          initialValues={{
            code: Tug_data?.CountryCode ? Tug_data?.CountryCode : "",
            Tug_name: Tug_data?.CountryName ? Tug_data?.CountryName : "",
            status: Tug_data.Status ? Tug_data.Status === true ? 1 : 0 : 0,
            // CommodityId: Tug_data?.CommodityId ? Tug_data?.CommodityId: "",
          }}
          validate={(values) => {
            const errors = {};
            if (!values.Tug_name || values.Tug_name === "") {
              errors.Tug_name = "Required";
            }
            if (!values.code || values.code === "") {
              errors.code = " Required";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              if (id) {
                const data = {
                  id: id,

                  name: values.Tug_name,
                  code: values.code,
                  status: values.status,
                  ModId: EmpId,
                };

                api
                  .post("api/country/update", data)
                  .then((respose) => {
                    const MySwal = withReactContent(Swal);

                    MySwal.fire({
                      icon: "success",
                      didOpen: () => {
                        MySwal.clickConfirm();
                      },
                    }).then(() => {
                      return MySwal.fire(
                        "สำเร็จ!",
                        "แก้ไขข้อมูลประเทศสำเร็จ !",
                        "success"
                      ).then((result) => {
                        if (result.isConfirmed) {
                          history.push("/Setting/Country");
                        }
                      });
                    });
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              } else {
                const data = {
                  name: values.Tug_name,
                  code: values.code,
                  status: values.status,
                  createId: EmpId,
                  // commodityId: values.CommodityId,
                };

                api
                  .post("api/country/create", data)
                  .then((respose) => {
                    const MySwal = withReactContent(Swal);

                    MySwal.fire({
                      icon: "success",
                      didOpen: () => {
                        MySwal.clickConfirm();
                      },
                    }).then(() => {
                      return MySwal.fire(
                        "สำเร็จ!",
                        "เพิ่มข้อมูลข้อมูลประเทศสำเร็จ !",
                        "success"
                      ).then((result) => {
                        if (result.isConfirmed) {
                          history.push("/Setting/Country");
                        }
                      });
                    });
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }

              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
                {!id ? "ประเทศ" : "แก้ชื่อประเทศ"}
              </h6>
              <Grid container>
                <Grid item xs={4} sm={3} md>
                  <TextField
                    name="Tug_name"
                    label="Country name"
                    variant="outlined"
                    placeholder="Country Name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{ width: "42%" }}
                    InputLabelProps={{ shrink: true }}
                    value={values.Tug_name}
                    classes={{ root: !values.Tug_name ? classes.customOutline : null }}
                    required
                  />
                  {/* {errors.Tug_name && touched.Tug_name&& errors.Tug_name} */}
                  <br />
                  <TextField
                    name="code"
                    label="Code"
                    variant="outlined"
                    placeholder="Code"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{ width: "42%", marginTop: "20px" }}
                    InputLabelProps={{ shrink: true }}
                    value={values.code}
                    classes={{ root: !values.code ? classes.customOutline : null }}
                    required
                  />

                  <div style={{ display: "flex" }}>
                    {/* <FormControl  style={{  width: "30%",marginTop: "10px",marginRight:"5px", marginBottom: "10px" }}>
                    <InputLabel id="select_status-label">CommodityName</InputLabel>
                    <Select
                      name="CommodityId"
                      id="CommodityName"
                      value={values.CommodityId}
                      label="CommodityName"
                     
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      {Commodilist.map((x) =>(
                      <MenuItem value={x.CommodityId}>{x.CommodityName}</MenuItem>))}
                      
                     
                    </Select>
                    
                  </FormControl> */}
                    <FormControl fullWidth style={{ marginTop: "10px" }}>
                      <InputLabel id="select_status-label1">Status</InputLabel>
                      <Select
                        name="status"
                        id="status"
                        value={values.status}
                        label="Status"
                        style={{
                          width: "20%",

                          marginBottom: "10px",
                        }}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <MenuItem value={1}>Active</MenuItem>
                        <MenuItem value={0}>InActive</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </Grid>
              </Grid>
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={history.goBack}
              >
                back
              </Button>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                disabled={isSubmitting}
              >
                {isSubmitting && <CircularProgress size={22} />}
                {!isSubmitting && "SAVE"}
              </Button>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
